module.exports = __webpack_public_path__ + "static/client-c801d452f4be95fa938879515a6272fd.png";